import { NewsContentType } from '@/types/enum';
import image1 from '@/assets/images/news/detail/20210330/1.jpg';
import image2 from '@/assets/images/news/detail/20210330/2.jpg';
import image3 from '@/assets/images/news/detail/20210330/3.jpg';
import image4 from '@/assets/images/news/detail/20210330/4.jpg';
import image5 from '@/assets/images/news/detail/20210330/5.jpg';

export default {
  id: '20210330', //  模块 id
  title: '传播青春正能量 壹佰米团委成立啦!', // 标题
  origin: '', // 新闻来源
  editor: '', // 编辑者
  content: [
    {
      type: NewsContentType.Text,
      text:
        '3月29日，叮咚买菜团组织正式升格为共青团团委，并召开了第一次团员代表大会。上海团市委副书记丁波，浦东新区团委书记林廷钧，张江科学城综合党委专职副书记陆勤，张江高科技园区综合团委书记俞冬群，壹佰米党总支常务副书记、叮咚买菜副总裁张奕等人出席了此次会议。',
    },
    {
      type: NewsContentType.Image,
      title: ['图|与会领导合影'],
      src: [image1],
    },
    {
      type: NewsContentType.Text,
      text:
        '作为在上海扎根成⻓的互联网生鲜企业，叮咚买菜吸引了不少热爱美⻝和生活的年轻人加入。公司现有团员300余名，⻘年上千名；业务覆盖团员超过4000名，⻘年人员30000名。从2018年12月27日壹佰米团支部正式成立，到如今壹佰米团支部顺利升格为团委，我们公司的青春力量在不断发展壮大。',
    },
    {
      type: NewsContentType.Text,
      text:
        '大会进行了壹佰米团委第一届委员选举，经过无记名投票选出11位委员组成壹佰米团委委员会，分别为陈茁（书记）、羊铭雨（副书记）、蔡嘉、海田丽、季羽婷、倪海灵、孙科、詹必成、张露月、张鹏、赵彤。',
    },
    {
      type: NewsContentType.Image,
      title: ['图|与会领导与壹佰米团委第一届委员合影'],
      src: [image2],
    },
    {
      type: NewsContentType.Text,
      text:
        '会上，上海团市委丁波副书记表示，叮咚买菜处于民生服务的最终端，要坚持思想引领，让大家不仅要有“铁军”的纪律，也要有“铁军”的意识；希望新一届团委要将团组织建设和企业的健康成⻓有机地结合起来，“以人为本”地服务好企业的青年员工，力所能及地给予他们关心与关爱；同时，在团组织建设方面，应坚持“一团一品”，聚焦优秀的品牌活动，做好团组织的品牌建设。',
    },
    {
      type: NewsContentType.Image,
      title: ['图|上海团市委丁波副书记致辞'],
      src: [image3],
    },
    {
      type: NewsContentType.Text,
      text:
        '浦东新区团委林廷钧书记在致辞中特意提到，团委在服务⻘年时，要想⻘年之所想，急⻘年之所急，为广大⻘年带来切实有效的服务。张江科学城综合党委陆勤书记对壹佰米团委成立表示了祝贺，并建议企业要运用好自身优势，与其他互联网企业共建，做好创新服务。',
    },
    {
      type: NewsContentType.Text,
      text:
        '壹佰米党总支常务副书记、叮咚买菜副总裁张奕在会上表示，⻘年是整个社会力量中最积极、最有生气的力量，在叮咚买菜，⻘年更是我们承担使命、实现愿景的未来。我们要坚守“铁军”传统，上下求索、开拓进取，超越前人就是对前人最高的致敬。',
    },
    {
      type: NewsContentType.Image,
      title: ['图|当选委员闪亮登场'],
      src: [image4],
    },
    {
      type: NewsContentType.Text,
      text:
        '在叮咚买菜，鼓励员工积极奋进、乐于助人，传递年轻人的正能量，是公司一直以来所倡导的价值观。在关爱视障人群方面，叮咚买菜除了持续改进前端平台系统，关注视障用户的需求外，还和上海“微笑明天”慈善基金会共同组织“爱心牵手、你我同行”主题活动，由⻘年志愿者陪伴视障者共同走出家⻔，融入社会。此外，在2020疫情爆发期间，叮咚买菜为上海援鄂368名医护工作者家属送出了超2万份，每份价值为100元的新鲜⻝材，覆盖了海军军医大学所有援鄂医护人员家庭，减轻了前线医护人员的后顾之忧。',
    },
    {
      type: NewsContentType.Text,
      text:
        '未来，团委还将组织许多关乎青年切实利益的活动，如即将在4-5月举行的与上飞院优质单身青年联谊活动，学四史等活动；也将积极带领叮咚的同学们参加团市委、团区委、张江综合团委组织的定向越野、互联网企业联谊、志愿者服务等活动，届时希望同学们呼朋引伴积极参加。',
    },
    {
      type: NewsContentType.Text,
      text:
        '壹佰米团委将积极承担组织和服务的⻆色，鼓励更多⻘年持续参与到帮助视障人群、老年人群等弱势群体的公益活动中去，也将为叮咚青年们带来更多更丰富的团建活动，传播⻘春正能量，体现⻘年人的责任与担当。',
    },
    {
      type: NewsContentType.Image,
      title: ['图|参会团员代表合影'],
      src: [image5],
    },
  ],
};
